import { AppConstants } from "@/core/Export";
import AppBlankLayout from "@/layouts/AppBlankLayout.vue";
import AppDefaultLayout from "@/layouts/AppDefaultLayout.vue";
import AppPunchInOutLayout from "@/layouts/AppPunchInOutLayout.vue";
import AppReportsLayout from "@/layouts/AppReportsLayout.vue";
import LoginPage from "@/pages/Login.vue";
import LoginByAccessTokenPage from "@/pages/LoginByAccessToken.vue";
import PunchInOutPage from "@/pages/PunchInOut.vue";
import EmployeePersonalAreaPage from "@/pages/employee/PersonalArea.vue";
import KioskAttendReportsPage from "@/pages/kiosk/KioskAttendReports.vue";
import ManagerEmployeeDetailsPage from "@/pages/manager/EmployeeDetails.vue";
import EmployeesListPage from "@/pages/manager/EmployeesList.vue";
import TeamLeaderPage from "@/pages/manager/TeamLeader.vue";
import ManagerPersonalAreaPage from "@/pages/manager/PersonalArea.vue";
import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: AppBlankLayout,
      children: [
        {
          path: "/",
          name: AppConstants.Routes.Login,
          component: LoginPage
        },
        {
          path: "/login/:accClientNo",
          name: AppConstants.Routes.LoginByAccessTokenPage,
          component: LoginByAccessTokenPage
        }
      ]
    },
    {
      beforeEnter: (to, from, next) => {
        let appEnv = store.state.appEnv;
        if (appEnv.Authenticated && appEnv.UserInfo.isManager && !appEnv.isAllowed(AppConstants.Permissions.PortalPunchInOutOnly)) {
          return next();
        } else {
          return next("/");
        }
      },
      path: "/manager",
      component: AppDefaultLayout,
      children: [
        {
          path: "/manager/employees/",
          name: AppConstants.Routes.M_Employees,
          component: EmployeesListPage
        },
        {
          path: "/manager/team_leader/",
          name: AppConstants.Routes.M_TeamLeader,
          component: TeamLeaderPage
        },
        {
          path: "/manager/employee",
          name: AppConstants.Routes.M_Employee_Details,
          component: ManagerEmployeeDetailsPage
        },
        {
          path: "/manager/personal_area/",
          name: AppConstants.Routes.M_PersonalArea,
          component: ManagerPersonalAreaPage
        }
      ]
    },
    {
      beforeEnter: (to, from, next) => {
        let appEnv = store.state.appEnv;
        if (appEnv.Authenticated && !appEnv.isAllowed(AppConstants.Permissions.PortalPunchInOutOnly)) {
          return next();
        } else {
          return next("/");
        }
      },
      path: "/employee",
      component: AppDefaultLayout,
      children: [
        {
          path: "/employee/personal_area/",
          name: AppConstants.Routes.E_PersonalArea,
          component: EmployeePersonalAreaPage
        }
      ]
    },
    {
      beforeEnter: (to, from, next) => {
        let appEnv = store.state.appEnv;
        if (appEnv.Authenticated && !appEnv.isAllowed(AppConstants.Permissions.PortalPunchInOutOnly)) {
          return next();
        } else {
          return next("/");
        }
      },
      path: "/reports",
      component: AppReportsLayout,
      children: [
        {
          path: "/reports/attendance_report/",
          name: AppConstants.Routes.R_AttendReport,
          component: KioskAttendReportsPage
        },
      ]
    },
    {
      beforeEnter: (to, from, next) => {
        let appEnv = store.state.appEnv;
        if (appEnv.Authenticated && appEnv.isAllowed(AppConstants.Permissions.PortalPunchInOutOnly)) {
          return next();
        } else {
          return next("/");
        }
      },
      path: "/punch_in_out",
      component: AppPunchInOutLayout,
      children: [
        {
          path: "/",
          name: AppConstants.Routes.PunchInOut,
          component: PunchInOutPage
        }
      ]
    }
  ]
});
